module.exports = __webpack_public_path__ + "static/img/article_banner.30ea2d48.png";